import React, { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import APProfilePhotoStyle from "./styles/APProfilePhoto.style";
import ManagerPhotoIcon from "./assets/default-profile-normal.png";
import { withTranslate } from "../../../core/TenantProvider";

interface APProfilePhotoProps extends WithStyles<typeof APProfilePhotoStyle> {
  className?: string,
  translate: Function,
  sourceURL?: string
}

class APProfilePhoto extends Component<APProfilePhotoProps, {}> {
  render() {
    const { classes, translate, sourceURL, className } = this.props;
    return (
      <div className={className}>
        <img
          src={sourceURL ? sourceURL : ManagerPhotoIcon}
          alt={translate("contact.affiliate.manager")}
          className={classes.managerIcon}
        />
      </div>
    );
  }
}

export default withTranslate(withStyles(APProfilePhotoStyle)(APProfilePhoto));
